import { useContext } from "react";
import { useAuth } from "../../../../contexts/auth";
import { KindOfOrder } from "../../../../types/enums";
import AddNoteButton from "../../../common/notes/components/AddNoteButton";
import { OrderNote } from "../../../common/notes/types/OrderNote";
import { MaterialOrderContext, RefetchScope } from "../context/MaterialOrderContext";

export default function MaterialOrderAddNoteButton() {

	const { order, modifyOrder, refetchOrder } = useContext(MaterialOrderContext);

	const emailSubject = order.details.moNumber;

	const { user } = useAuth();
	let companyIDs = [user?.companyId!];

	if (order.details.purchaseOrders) {
		for (let purchaseOrder of order.details.purchaseOrders) {
			if (!companyIDs.includes(purchaseOrder.distributorID))
				companyIDs.push(purchaseOrder.distributorID);
		}
	}

	const params = {
		showNoteType: false,
		orderID: order.details.materialOrderID,
		kindOfOrder: KindOfOrder.MaterialOrder,
		temporaryNoteCount: order.details?.notes?.length ?? 0,
		companyIDs: companyIDs,
		emailSubject: emailSubject,
		onNoteAdded: (note: OrderNote) => {
			if (order.details.materialOrderID) {
				refetchOrder(RefetchScope.Notes);
			}
			else {
				var newNotes = (order.details.notes ?? []).concat(note);
				modifyOrder({ ...order.details, notes: newNotes });
			}
		}
	}

	return (
		<>
			<AddNoteButton
				caption="Add Material Order Note"
				params={params}
			/>
		</>
	)
}
